import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export function Chatbot() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/ai-assistant");
  };

  return (
    <Button
      onClick={handleClick}
      className="fixed bottom-6 right-6 z-50 h-10 w-10 rounded-full bg-gradient-to-br from-primary to-accent shadow-lg shadow-primary/25 hover:shadow-xl hover:shadow-primary/30 transition-all duration-300 hover:scale-110"
      size="icon"
      aria-label="Open AI Assistant"
    >
      <span className="text-sm font-semibold tracking-tight text-white">AI</span>
      <span className="sr-only">Open AI Assistant</span>
    </Button>
  );
}

